import { Fragment } from "react";
import type { MouseEvent, ReactElement, ReactNode } from "react";
import { ButtonKind, ButtonSize, ButtonLink, Heading } from "@stubhub/broadway-web";
import { Content } from "src/shared/components/content";
import { cardClass, separatorClass, title } from "./event-list-carousel.recipes";

export interface EventListCardProps<T> {
  /** The chunk of items for this card. */
  items: T[];
  /** Render function forwarded from EventListCarousel. */
  renderItem: (item: T, index: number) => ReactElement;
  header: string | ReactNode;
  viewAllUrl: string;
  onViewAllClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  size?: "default" | "mobile";
}

export const EventListCard = <T,>({
  items,
  header,
  viewAllUrl,
  onViewAllClick,
  renderItem,
  size,
}: EventListCardProps<T>): ReactElement => (
  <div className={cardClass({ size })}>
    {header && <Heading className={title}>{header}</Heading>}
    {items.map((item, index) => (
      <Fragment key={index}>
        {index > 0 && <div className={separatorClass} />}
        {renderItem({ ...item, isLast: items.length === index + 1 }, index)}
      </Fragment>
    ))}
    {viewAllUrl && (
      <ButtonLink href={viewAllUrl} onClick={onViewAllClick} size={ButtonSize.Small} kind={ButtonKind.Neutral}>
        <Content id="cid$#4242189#" />
      </ButtonLink>
    )}
  </div>
);
